<template>
  <v-app>
    <v-navigation-drawer v-model="drawer" app clipped :right="$vuetify.rtl">
      <AppBarNav
        v-if="$vuetify.breakpoint.mdAndDown"
        :drawer="drawer"
        :is-in-drawer="true"
        @toggle-drawer="toggleDrawer"
      />
      <TheSideBar />
    </v-navigation-drawer>

    <AppBarNav :drawer="drawer" @toggle-drawer="toggleDrawer" />

    <v-content>
      <router-view></router-view>
    </v-content>

    <v-footer
      dark
      padless
      color="primary"
      class="d-flex flex-row justify-space-between px-4 py-1 footer-container"
    >
      <div>&copy; {{ currentYear }} HiiL</div>
      <div class="d-flex align-center">
        <div>{{ $t("interface.poweredBy") }}</div>
        <a href="https://www.pngk.org" target="_blank">
          <ThePNGKLogo :width="80"
        /></a>
      </div>
    </v-footer>
  </v-app>
</template>

<script>
import AppBarNav from "@/components/AppBarNav.vue";
import TheSideBar from "@/components/TheSideBar.vue";
import ThePNGKLogo from "@/components/ThePNGKLogo.vue";
// log the hash
import Hash from "@/assets/gitHash.json";
console.log(Hash);

export default {
  components: {
    AppBarNav,
    TheSideBar,
    ThePNGKLogo
  },
  computed: {
    drawer: {
      get() {
        return this.$store.state.drawerOpen;
      },
      set(value) {
        this.$store.dispatch("toggleDrawer", value);
      }
    },
    currentYear() {
      return new Date().getFullYear();
    },
    currentLocale() {
      return this.$i18n.locale;
    }
  },
  watch: {
    currentLocale: {
      handler: function(locale) {
        this.$vuetify.rtl = locale === "ar";
      },
      immediate: true
    }
  },
  methods: {
    toggleDrawer() {
      this.drawer = !this.drawer;
    }
  }
};
</script>

<style scoped>
.footer-container {
  z-index: 4;
}
</style>
